import React from 'react'
import { Widget } from 'widgets-for-react'
import { any, fromJSX, Updater } from 'widgets-for-react'
import { Tags } from '../../../sharedLayout/tags'
import { blocksWidget } from '../../blocks/blocksWidget'
import { cmsPageStateUpdaters, NewsPage, Page } from '../../cmsPageState'
import { NewsPageHeader } from './newsPageLayout'
import { slugify } from '../../../../utils/utils'

export const newsPageWidget =
  (acceptVideoCookie: () => void) =>
  (page: NewsPage): Widget<Updater<Page>> =>
    any([
      fromJSX(() => (
        <NewsPageHeader
          title={page.title}
          intro={page.intro}
          image={page.image}
          link={page.link}
          date={page.date}
          author={page.author}
          breadcrumbs={[
            { title: 'Spaarne Gasthuis', url: '/' },
            { title: 'Nieuws', url: '/nieuws' },
            { title: page.title, url: page.url },
          ]}
          dossier={page.dossier ? { title: page.dossier.Title ?? "", url: page.dossier.DossierPage?.AbsolutePath ?? "#" } : undefined}
        />
      )),
      blocksWidget(acceptVideoCookie)(page.blocks).map((updater) => cmsPageStateUpdaters.blocksUpdater(updater)),
      fromJSX(() => (
        <Tags
          tags={page.tags
            .map((tag) => ({ title: tag, url: `/nieuws-en-agenda?tags=${tag}` }))
            .concat(
              page.departments.map((department) => ({
                title: department,
                url: `/nieuws-en-agenda?department=${department}`,
              }))
            )
            .concat(
              page.subDepartments.map((subDepartment) => ({
                title: subDepartment,
                url: `/nieuws-en-agenda?subdepartment=${subDepartment}`,
              }))
            )
            .concat(
              page.specialists.map((specialist) => ({
                title: specialist,
                url: `/nieuws-en-agenda?specialist=${specialist}`,
              }))
            )
            .concat(
              page.centra.map((centrum) => ({
                title: centrum,
                url: `/nieuws-en-agenda?centrum=${centrum}`,
              }))
            )
            .concat(
              page.subcentra.map((subcentrum) => ({
                title: subcentrum,
                url: `/nieuws-en-agenda?subcentra=${subcentrum}`,
              }))
            )
          }
        />
      )),
    ])
